import Vue from 'vue';
import VueGtm from 'vue-gtm';
import App from '../src/App.vue';
import store from '../src/store/index';
import router from '../src/router';
import i18n from '../locales/locales';
import '../src/assets/hacky.css';
import '../src/lib/basePackConfig';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify/lib';

Vue.use(VueGtm, {
  id:           'GTM-NL6QKJ',
  enabled:      process.env.NODE_ENV !== 'development',
  debug:        false,
  loadScript:   true,
  vueRouter:    router,
  ignoredViews: ['vue-registrar'], // regular gtm will handle this page
});

Vue.use(Vuetify);

new Vue({
  i18n,
  router,
  store,
  render:  (h) => h(App),
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi',
    },
  }),
}).$mount('#app');
